import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { FaqChannelsState, SLICE_NAME } from './models';

const faqChannelsSelector = (state: RootState): FaqChannelsState => state[SLICE_NAME];

export const selectFaqChannels = createSelector(faqChannelsSelector, (state: FaqChannelsState) => state.channels);

export const selectFaqChannelsIsLoading = createSelector(
  faqChannelsSelector,
  (state: FaqChannelsState) => state.isLoading,
);

export const selectFaqChannelsError = createSelector(faqChannelsSelector, (state: FaqChannelsState) => state.error);
